import { Slide } from "@jelly/lesson";

import { task as task05 } from "../../../../../task/course-05/lesson-22/task-05";

const task: Slide = {
  titleHtml:
    "In repeated measurements of reverberation time in the receiving rooms and the levels<br>in both rooms, the standard deviations of the measured data are:",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task05.id,
        },
      },
    },
  },
};

export default task;
